import React, {
    useState,
    useEffect
} from "react";


export default function UtilisationKpiBoxDate({
    title,
    figure,
    width,
    hour
})
{
    //--------------------------------------------------------
    // State
    //--------------------------------------------------------

    const [displayFigure, setDisplayFigure] =
        useState("");

    const [displayHour, setDisplayHour] =
        useState("0");


    //--------------------------------------------------------
    // Values
    //--------------------------------------------------------

    useEffect(
        () =>
        {
            if(
                figure !== undefined
                &&
                figure !== null
            )
            {
                setDisplayFigure(
                    figure
                );
            }

            if(
                hour !== undefined
                &&
                hour !== null
            )
            {
                setDisplayHour(
                    hour
                );
            }
        },
        [
            figure,
            hour
        ]
    );


    //========================================================
    // Styles
    //========================================================

    //--------------------------------------------------------
    // KPI
    //--------------------------------------------------------

    const thisContainer =
    {
        display:
            "flex",

        flexDirection:
            "column",

        width:
            width || "100%",

        height:
            "60px",

        boxSizing:
            "border-box",

        //----------------------------------------------------
        // Structural graphite
        //----------------------------------------------------

        background:
            `linear-gradient(
                145deg,
                #292d31 0%,
                #181c1f 52%,
                #0b0d0f 100%
            )`,

        //----------------------------------------------------
        // Structural = square
        //----------------------------------------------------

        borderRadius:
            "0px",

        border:
            "1px solid rgba(255,255,255,0.07)",

        boxShadow:
            "0 2px 5px rgba(0,0,0,0.16)",

        overflow:
            "hidden"
    };


    //--------------------------------------------------------
    // Title
    //--------------------------------------------------------

    const titleContainer =
    {
        display:
            "flex",

        height:
            "22px",

        minHeight:
            "22px",

        alignItems:
            "center",

        justifyContent:
            "center",

        padding:
            "0 8px",

        boxSizing:
            "border-box",

        fontSize:
            "13px",

        fontWeight:
            500,

        color:
            "rgba(255,255,255,0.76)",

        borderBottom:
            "1px solid rgba(255,255,255,0.07)"
    };


    //--------------------------------------------------------
    // Date
    //--------------------------------------------------------

    const figureContainer =
    {
        display:
            "flex",

        flex:
            "1",

        alignItems:
            "center",

        justifyContent:
            "center",

        fontSize:
            "16px",

        fontWeight:
            500,

        color:
            "#45afe0",

        lineHeight:
            "1"
    };


    //--------------------------------------------------------
    // Hour
    //--------------------------------------------------------

    const hourContainer =
    {
        display:
            "flex",

        height:
            "17px",

        minHeight:
            "17px",

        alignItems:
            "flex-start",

        justifyContent:
            "center",

        fontSize:
            "11px",

        color:
            "rgba(255,255,255,0.64)",

        lineHeight:
            "1"
    };


    //========================================================
    // Render
    //========================================================

    return (

        <div
            style={
                thisContainer
            }
        >

            <div
                style={
                    titleContainer
                }
            >
                {title}
            </div>

            <div
                style={
                    figureContainer
                }
            >
                {displayFigure}
            </div>

            <div
                style={
                    hourContainer
                }
            >
                ({displayHour}:00)
            </div>

        </div>

    );
}